var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Controller } from 'react-hook-form';
import { Input } from '../..';
import StyledFormWrapper from '../styles';
var CarForm = function (_a) {
    var fields = _a.fields, errors = _a.errors, control = _a.control, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b;
    return (React.createElement(StyledFormWrapper, null,
        React.createElement(Controller, { name: "brand", control: control, render: function (_a) {
                var _b;
                var field = _a.field;
                return React.createElement(Input, __assign({}, field, { floatingLabel: fields.brand, errorMessage: (_b = errors.brand) === null || _b === void 0 ? void 0 : _b.message, autoFocus: autoFocus }));
            } }),
        React.createElement(Controller, { name: "color", control: control, render: function (_a) {
                var _b;
                var field = _a.field;
                return React.createElement(Input, __assign({}, field, { floatingLabel: fields.color, errorMessage: (_b = errors.color) === null || _b === void 0 ? void 0 : _b.message }));
            } }),
        React.createElement(Controller, { name: "license", control: control, render: function (_a) {
                var _b;
                var field = _a.field;
                return React.createElement(Input, __assign({}, field, { floatingLabel: fields.license, errorMessage: (_b = errors.license) === null || _b === void 0 ? void 0 : _b.message }));
            } })));
};
export default CarForm;
